module.exports = __webpack_public_path__ + "assets/img/lastz3.36cb01aa.png";